/* import __COLOCATED_TEMPLATE__ from './cards.hbs'; */
import { STRIPE_PAYMENT_INSTRUMENT_TYPE_CARD } from 'client-portal/utils/stripe-payment-instrument';
import { action } from '@ember/object';
import CheckoutInstrumentSection from './instrument-section';
import styles from './cards.module.scss';

export default class SiteBillingPaymentInstrumentPaymentModalCheckoutCards extends CheckoutInstrumentSection {
  styles = styles;

  get hasSavedCard() {
    return this.billingModals.client.cards.length > 0;
  }

  get selectedCard() {
    return this.selectedInstrument(STRIPE_PAYMENT_INSTRUMENT_TYPE_CARD);
  }

  @action
  addNewCard() {
    this.args.onAddCard(STRIPE_PAYMENT_INSTRUMENT_TYPE_CARD);
  }
}
